export default __webpack_public_path__ + "static/media/notice.61f2e202.jpg";